module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-client":"Delete Client | Delete {n} Clients","client-deleted":"Client deleted","failed-delete-client":"Failed to delete client","enabled-filter":"Enabled Filter"}}')
  delete Component.options._Ctor
}
